/* eslint-disable no-unused-vars */
export type ChartColumnOptions = {
  chart: {
    id: string
  },
  xaxis: {
    categories: string[]
  }
}

export type ChartColumnSeries = {
  name: string,
  data: number[]
}

export const greenColors: string[] = ['#06BAB2', '#098C86', '#9FFCF8', '#C7EBEB']
export const labelGreenColors: string[] = ['#4B4B4B', '#ffffff', '#ffffff', '#ffffff']

export const redColors: string[] = ['#EF6167', '#BE373D', '#FFADB1', '#FFDCDE']
export const labelRedColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const yellowColors: string[] = ['#ffd485', '#ffff00']
export const labelYellowColors: string[] = ['#ffd485']

export const blueColors: string[] = ['#2D4054', '#17222F', '#6494C6', '#9ED6EE']
export const labelBlueColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const greyColors: string[] = ['#787878', '#4B4B4B', '#999999', '#B6B6B6']
export const labelGreyColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const orangeColors: string[] = ['#FF922B', '#E37B00', '#FFC888', '#FF9F40']
export const labelOrangeColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const rainbowColors: string[] = ['#dee2ff', '#4cc9f0', '#f72585', '#023047', '#24842C', '#d62828', '#FFB703', '#ffc8dd', '#70e000', '#540b0e']
export const labelRainbowColors: string[] = ['#000214', '#020F13', '#140109', '#ffffff', '#ffffff', '#ffffff', '#291D00', '#3D0017', '#0A1400', '#FADBDC']

export const multiColors: string[] = ['#26A0FC', '#26E7A6', '#8B75D7', '#FEBC3B', '#FF6178']
export const labelMultiColors: string[] = ['#070707', '#070707', '#02011B', '#070707', '#050506']

export const twoColors: string[] = ['#54EBD0', '#FF0007']
export const labelTwoColors: string[] = ['#0B180C', '#180000']

export const threeColors: string[] = ['#bdebf1', '#c7ebbf', '#ffd485']
export const labelThreeColors: string[] = ['#bdebf1', '#c7ebbf', '#ffd485']

export const cleanBlueColors: string[] = ['#bdebf1']
export const labelCleanBlueColors: string[] = ['#bdebf1']

export const cleanGreenColors: string[] = ['#54EBD0']
export const labelCleanGreenColors: string[] = ['#54EBD0']

export enum ChartColumnThemes {
  default = 'green',
  green = 'green',
  red = 'red',
  blue = 'blue',
  yellow = 'yellow',
  cleanBlue = 'cleanBlue',
  cleanGreen = 'cleanGreen',
  grey = 'grey',
  orange = 'orange',
  rainbow = 'rainbow',
  twocolors = 'twocolors',
  multi = 'multi',
  threecolors = 'threecolors'
}

export type ChartColumnTheme = {
  [ChartColumnThemes.default]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.green]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.red]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.blue]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.grey]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.orange]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.yellow]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.rainbow]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.twocolors]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.threecolors]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartColumnThemes.multi]: {
    seriesColors: string[]
    labelsColors: string[]
  }
  [ChartColumnThemes.cleanBlue]: {
    seriesColors: string[]
    labelsColors: string[]
  }
  [ChartColumnThemes.cleanGreen]: {
    seriesColors: string[]
    labelsColors: string[]
  }
}

export const themes: ChartColumnTheme = {
  [ChartColumnThemes.default]: {
    seriesColors: greenColors,
    labelsColors: labelGreenColors
  },
  [ChartColumnThemes.green]: {
    seriesColors: greenColors,
    labelsColors: labelGreenColors
  },
  [ChartColumnThemes.red]: {
    seriesColors: redColors,
    labelsColors: labelRedColors
  },
  [ChartColumnThemes.blue]: {
    seriesColors: blueColors,
    labelsColors: labelBlueColors
  },
  [ChartColumnThemes.grey]: {
    seriesColors: greyColors,
    labelsColors: labelGreyColors
  },
  [ChartColumnThemes.orange]: {
    seriesColors: orangeColors,
    labelsColors: labelOrangeColors
  },
  [ChartColumnThemes.yellow]: {
    seriesColors: yellowColors,
    labelsColors: labelYellowColors
  },
  [ChartColumnThemes.rainbow]: {
    seriesColors: rainbowColors,
    labelsColors: labelRainbowColors
  },
  [ChartColumnThemes.twocolors]: {
    seriesColors: twoColors,
    labelsColors: labelTwoColors
  },
  [ChartColumnThemes.threecolors]: {
    seriesColors: threeColors,
    labelsColors: labelThreeColors
  },
  [ChartColumnThemes.multi]: {
    seriesColors: multiColors,
    labelsColors: labelMultiColors
  },
  [ChartColumnThemes.cleanBlue]: {
    seriesColors: cleanBlueColors,
    labelsColors: labelCleanBlueColors
  },
  [ChartColumnThemes.cleanGreen]: {
    seriesColors: cleanGreenColors,
    labelsColors: labelCleanGreenColors
  }
}
